import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Axios from 'axios'
import LightBootstrap from './light-bootstrap-main'
import VueRouter from 'vue-router'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import AsyncComputed from 'vue-async-computed'
import moment from 'moment'
import VueGlobalVar from 'vue-global-var'
import Vuelidate from 'vuelidate'
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import "font-awesome/css/font-awesome.min.css";

Vue.config.productionTip = false;

// set auth header
Axios.defaults.headers.common['Authorization'] = `Bearer ${store.state.token}`;

Vue.use(VueRouter)
Vue.use(LightBootstrap)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(AsyncComputed)
Vue.use(Vuelidate);
Vue.use(VueGlobalVar, {
  globals: {
    $TablesEnum: Object.freeze({
      user: 1,
      userRole: 2,
      userPermission: 3,
      userRolePermission: 4,
      userUserRole: 5,
      insuranceEventType: 6,
      reportDamageType: 7,
      damagedType: 8,
      otherAuthorizedPersonType: 9,
      insuranceUserCompany: 10,
      lessEventData: 11,
      insuranceEvent: 12,
      insuranceEventDocuments: 13
    }),
    $EmailTypeGlobal: {
      newUser: 1,
      forgottenPassword: 2
    }
  },
});

Vue.use(Datetime)


Vue.component('VueFontawesome', require('vue-fontawesome-icon/VueFontawesome.vue').default);

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('DD.MM.YYYY hh:mm')
  }
})

// configure router
const routes = new VueRouter({
  router, // short for routes: routes
  linkActiveClass: 'nav-item active',
  scrollBehavior: (to) => {
    if (to.hash) {
      return {selector: to.hash}
    } else {
      return { x: 0, y: 0 }
    }
  }
})

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');